import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { VolunteerOption, VolunteerOptionInput } from "./VolunteerOption";
import { observer } from "mobx-react";

interface VolunteerOptionsProps {
  value?: VolunteerOptionInput[];
  flexible?: boolean;
  onChange?: (value: VolunteerOptionInput[]) => void;
}

export const VolunteerOptions = observer(({ value = [], flexible = false, onChange }: VolunteerOptionsProps) => {
  const [model, setModel] = useState<VolunteerOptionInput[]>(value || []);

  useEffect(() => {
    setModel(value || []);
  }, [value]);

  const onValue = (i, val) => {
    model[i] = val;
    onChange && onChange([...model]);
  };

  const onAdd = () => {
    onChange && onChange([...model, {}]);
  };

  const onDel = (i) => {
    model.splice(i, 1);
    onChange && onChange([...model]);
  };

  return (
    <div>
      <div>
        {model.map((x, i) => (
          <VolunteerOption
            key={i}
            value={x}
            onChange={(val) => onValue(i, val)}
            canDel={model.length > 1}
            onDel={() => onDel(i)}
          />
        ))}
      </div>
      {!flexible && (
        <div style={{ textAlign: "right" }}>
          <Button onClick={onAdd}>+</Button>
        </div>
      )}
    </div>
  );
});
